export enum HeroSectionType {
    PATIENT = 'patient',
    DOCTOR = 'doctor',
    CLINIC = 'clinic',
    GENERAL = 'general',
}